import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Pre from "../views/Pre.vue"
Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "home",
    component: Home,
  },
  // {
  //   path: '/pre',
  //   name: 'pre',
  //   component: Pre
  // }
];

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return  {
        el: to.hash,
        behavior: 'smooth',
      };
    } else {
      return {
        left: 0,
        top: 0
      };
    }
  },
  routes
});

export default router;